import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useEffectOnce } from 'react-use'
import { Header, ListingTemplate, Tabs } from '../../../views/components'
import SettingsIcon from '../../../views/components/atoms/Icons/Security/ShieldUserFill'
import { agencyApiEvents } from '../../api/agency'
import { TAdminUserLookup } from '../../api/user/types'
import UserAccess from './UserAccess/UserAccess'
import AgencyMembers from './AgencyMembers/AgencyMembers'
import styles from './AdminAgencyAccessContent.module.scss'

type TProps = {
  onGrantAccess: (user: TAdminUserLookup) => void
}

const AdminAgencyAccessContent = ({ onGrantAccess }: TProps) => {
  const dispatch = useDispatch()
  // Must be controlled: the shared Tabs always passes selectedIndex, and
  // react-tabs treats undefined as controlled with nothing selected, so no
  // panel would render.
  const [tab, setTab] = useState(0)

  useEffectOnce(() => {
    // Both tabs pick agencies from the full listing, which nothing else on
    // this page fetches.
    dispatch(agencyApiEvents.agencyListing_request())
  })

  return (
    <ListingTemplate
      Header={<div style={{ minHeight: '50px' }}></div>}
      Body={
        <div className={styles.root}>
          <Header icon={<SettingsIcon />} text="Users" />
          <Tabs
            selectedTab={tab}
            onTabChange={index => setTab(index)}
            tabs={[
              { title: 'By agency', content: <AgencyMembers /> },
              { title: 'By user', content: <UserAccess onGrantAccess={onGrantAccess} /> },
            ]}
          />
        </div>
      }
    />
  )
}

export default AdminAgencyAccessContent
